import './index.scss'
const Logo = () => {
    return (
        <div className='logo-container'>
        </div>
    )
}
export default Logo